module.exports = __webpack_public_path__ + "img/match.af232386.svg";